var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"app-footer"},[_c('span',[_c('a',{attrs:{"href":"http://apptimus.media"}},[_vm._v("Apptimus Media")]),_vm._v(" © "+_vm._s(new Date().getFullYear())+".")])])
}
var staticRenderFns = []

export { render, staticRenderFns }